const font = process.env.REACT_APP_FONT;

export default font;